import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center flex-wrap ga-4 mb-6"
}
const _hoisted_2 = { class: "ms-filter" }
const _hoisted_3 = { class: "text-caption text-disabled" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AssistantEditor = _resolveComponent("AssistantEditor")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_AgentSummaryCard = _resolveComponent("AgentSummaryCard")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_AssistantKindDialog = _resolveComponent("AssistantKindDialog")!
  const _component_AddModelDialog = _resolveComponent("AddModelDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "py-8 px-4",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.editorAgent)
        ? (_openBlock(), _createBlock(_component_AssistantEditor, {
            key: 0,
            agent: _ctx.editorAgent,
            "is-draft": !!_ctx.draftAgent,
            onBack: _ctx.onBack,
            onSaved: _ctx.onSaved,
            onDeleted: _ctx.onDeleted
          }, null, 8, ["agent", "is-draft", "onBack", "onSaved", "onDeleted"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-h4 font-weight-bold mb-2" }, "Assistants", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", {
              class: "text-body-1 text-medium-emphasis mb-8",
              style: {"max-width":"580px"}
            }, " Your AI assistants — each one a model with a job, the instructions it follows and the tools it can use. Set them up in plain language here; switch to Advanced mode anytime for the full controls. ", -1)),
            (_ctx.agents.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_v_btn_toggle, {
                    modelValue: _ctx.sortOrder,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortOrder) = $event)),
                    mandatory: "",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        icon: "mdi-sort-variant-remove",
                        value: "default",
                        size: "small",
                        title: "Default Order"
                      }),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-sort-alphabetical-ascending",
                        value: "asc",
                        size: "small",
                        title: "Sort Ascending"
                      }),
                      _createVNode(_component_v_btn, {
                        icon: "mdi-sort-alphabetical-descending",
                        value: "desc",
                        size: "small",
                        title: "Sort Descending"
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_v_combobox, {
                      modelValue: _ctx.search,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
                      items: _ctx.configList,
                      "return-object": false,
                      "item-title": "name",
                      "item-value": "name",
                      clearable: "",
                      variant: "outlined",
                      density: "compact",
                      label: "Filter assistants",
                      "hide-details": ""
                    }, {
                      append: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.filteredAgents.length), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "items"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6",
                  lg: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      variant: "outlined",
                      rounded: "lg",
                      height: "100%",
                      "min-height": "168",
                      class: "pa-6 d-flex flex-column justify-center ga-2 ms-add",
                      onClick: _ctx.newAssistant
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_avatar, {
                          color: "primary",
                          variant: "tonal",
                          rounded: "lg",
                          size: "44"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "mdi-plus" })
                          ]),
                          _: 1
                        }),
                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-subtitle-1 font-weight-bold" }, "New assistant", -1)),
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-caption text-disabled" }, "Build one your way — or add a brain", -1))
                      ]),
                      _: 1,
                      __: [4,5]
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAgents, (a) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: a.config.id,
                    cols: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AgentSummaryCard, {
                        agent: a,
                        variant: "desktop",
                        "model-configs-by-id": _ctx.modelConfigsById,
                        username: _ctx.username,
                        onEdit: ($event: any) => (_ctx.openId = a.config.id)
                      }, null, 8, ["agent", "model-configs-by-id", "username", "onEdit"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ], 64)),
      _createVNode(_component_AssistantKindDialog, {
        modelValue: _ctx.picker,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.picker) = $event)),
        onPick: _ctx.onPickKind
      }, null, 8, ["modelValue", "onPick"]),
      _createVNode(_component_AddModelDialog, {
        modelValue: _ctx.addModelOpen,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addModelOpen) = $event)),
        connected: _ctx.connectedSet,
        onCreated: _ctx.onModelCreated
      }, null, 8, ["modelValue", "connected", "onCreated"])
    ]),
    _: 1
  }))
}